<template>
  <div class="scroll-header absolute">
    <div :class="{'right_details_header no-bottom-border' : mode!='ab' }">
      <!-- AllBet -->
      <template v-if="mode=='ab'">
        <div class="wrap-title">
          <div class="group-back cursor-pointer" @click="backToMain()">
            <i aria-hidden="true" role="presentation" class="back q-icon icon-back c-icon set-color"
              style="color: rgb(171, 186, 200);"></i>
          </div>
          <div class="title ellipsis allow-user-select" v-html="sortedMatchEventList.lgecapt"></div>
          <div class="right-icon">
            <span v-if="!showhideBanner" @click="showhide_Banner(true)">{{sportAllBetLang['ALL_BET.LBL_SHOWSCRBOARD']}}</span>
            <!-- <div class="sr-link-icon-w">
              <i aria-hidden="true" role="presentation" class="q-icon icon-signal c-icon set-color" style="color: rgb(171, 186, 200);"></i>
            </div> -->
            <!-- <div class="refresh">
              <div class="c-refresh fit yb-flex-center cursor-pointer">
                <div class="icon-wrap" @click="refreshTbl(token.arr_5)">
                  <span class="icon-balance_refresh">
                    <span class="path1"></span>
                    <span class="path2" style="right:13.5px; position:absolute;"></span>
                    <span class="path3" style="right:14.5px; position:absolute;"></span>
                  </span>
                </div>
              </div>
            </div> -->

            <div class="refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg" @click="refreshTbl(token.arr_5)">
              <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn">
                <div id="tblRefresh" class="icon-wrap">
                  <i aria-hidden="true" role="presentation" class="q-icon icon-tbl_refresh c-icon" style="font-size: 18px;"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showhideBanner" class="head-info relative-position esports-head-info-1" :class="getABetSport()" ref="testa">
          <div class="right_match_info info-upd full-width vrow justify-center">
            <template v-if="sortedMatchEventList.rbinfo && sortedMatchEventList.sptid>2">
              <div data-v-9d87a3d9="" data-v-46377044="" class="more-info">
                <div data-v-9d87a3d9="" class="more-time">
                  <div data-v-9d87a3d9="" class="time-tips">
                    <div data-v-e30046ca="" data-v-9d87a3d9="" class="c-match-process text-center row a-row">
                      <div data-v-e30046ca="" class="jingcai" style="display: none;"></div>
                      <div data-v-e30046ca="" class="time-content">
                        <div data-v-e30046ca="" class="process-name">
                        <div data-v-e30046ca="" class="process_name" v-if="sortedMatchEventList.sptid==3 || sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LBL_SET_S1'] : sportTableLang.table['SPORT_TABLE.LBL_SET_'+firstEvent.rbinfo.st] }}</div>
                        <div data-v-e30046ca="" class="process_name" v-else-if="sortedMatchEventList.sptid==23">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_INN_'+sortedMatchEventList.rbinfo.st] }}</div>
                        <div data-v-e30046ca="" class="process_name" v-else-if="sortedMatchEventList.sptid==14">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_PERIOD_'+sortedMatchEventList.rbinfo.st] }}</div>
                        <div data-v-45641ae6="" class="process_name" v-else-if="sortedMatchEventList.sptid==20">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_GAME_'+sortedMatchEventList.rbinfo.st] }}</div>
                        <div data-v-45641ae6="" class="process_name" v-else-if="sortedMatchEventList.sptid==15">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_FRAME_'+sortedMatchEventList.rbinfo.st] }}</div>
                        <div data-v-45641ae6="" class="process_name" v-else-if="sortedMatchEventList.sptid==13">{{ sortedMatchEventList.rbinfo.st=='NL' ? sportTableLang.table['SPORT_TABLE.LIVE'] : sportTableLang.table['SPORT_TABLE.LBL_Q_'+sortedMatchEventList.rbinfo.st] }}</div>
                        
                        <div data-v-e30046ca="" class="process_name" v-else-if="sortedMatchEventList.sptid==19">
                          <template v-if="sortedMatchEventList.rbinfo.st=='NL'">
                            {{ sportTableLang.table['SPORT_TABLE.LIVE'] }}
                          </template>
                          <template v-else-if="sortedMatchEventList.rbinfo.st=='H1'">
                            {{ sportAllBetLang['ALL_BET.LBL_1HT'] }}
                          </template>
                          <template v-else-if="sortedMatchEventList.rbinfo.st=='H2'">
                            {{ sportAllBetLang['ALL_BET.LBL_2HT'] }}
                          </template>
                        </div>
                        <div data-v-e30046ca="" class="process_name" v-else>{{ sportTableLang.table['SPORT_TABLE.LIVE'] }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-9d87a3d9="" class="scorll-handel">
                  <span data-v-9d87a3d9="" class="scroll-arrow" id="prev-sn" v-if="sortedMatchEventList.sptid==15">
                    <i data-v-e826ac10="" data-v-9d87a3d9="" class="q-icon icon-arrow arrow-left c-icon set-color" aria-hidden="true" style="color:rgb(109, 114, 120); font-size: 10px; display: none;"> </i>
                  </span>
                  <div data-v-9d87a3d9="" class="time-node is_details">
                    <template v-if="sortedMatchEventList.sptid==3 || sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21"> <!--  || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 -->
                      <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[sortedMatchEventList.sptid]" v-if="n==1&&sortedMatchEventList.rbinfo.st=='NL'">{{ n }}</span>
                      <span data-v-9d87a3d9="" class="" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-else>{{ n }}</span>
                    </template>
                    <!-- <template v-else-if="sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23">
                      <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[sortedMatchEventList.sptid]" v-if="n==1&&sortedMatchEventList.rbinfo.st=='NL'">{{ n }}</span>
                      <span data-v-9d87a3d9="" class="" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-else-if="n!=sportColLength[sortedMatchEventList.sptid]">{{ n }}</span>
                      <span data-v-9d87a3d9="" class="" v-else :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.sptid==23 ? sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : sportTableLang.table['SPORT_TABLE.LBL_OS_OT'] }}</span>
                    </template> -->
                    <!-- <template v-else-if="sortedMatchEventList.sptid==13">
                      <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[sortedMatchEventList.sptid]" v-if="n==1&&sortedMatchEventList.rbinfo.st=='NL'">Q{{ n }}</span>
                      <span data-v-9d87a3d9="" class="" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-else-if="n<3">Q{{ n }}</span>
                      <span data-v-9d87a3d9="" class="" :class="sortedMatchEventList.rbinfo.st=='S'+(n-1)?'current_color':''" v-else-if="n>3">Q{{ n-1 }}</span>
                      <span data-v-9d87a3d9="" class="" v-else>{{ sportTableLang.table['SPORT_TABLE.LBL_SCORE_HT'] }}</span>
                    </template> -->
                    <!-- <template v-else-if="sortedMatchEventList.sptid==19">
                        <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_1HT']" class="result-icon rs_jin_shang"></div></div>
                        <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_FT']" class="result-icon rs_jin_quan"></div></div>
                    </template> -->
                    <template v-else-if="sortedMatchEventList.sptid==13 || sortedMatchEventList.sptid==23 || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 || sortedMatchEventList.sptid==19 || sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==7">
                      <template v-if="sortedMatchEventList.rbinfo.score['S1'] && (sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23)">
                        <span data-v-9d87a3d9="" class="current_color" v-for="n in sportColLength[sortedMatchEventList.sptid]" v-if="n==1&&sortedMatchEventList.rbinfo.st=='NL'">{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-else-if="n!=sportColLength[sortedMatchEventList.sptid]">{{ n }}</span>
                        <span data-v-9d87a3d9="" class="" v-else :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.sptid==23 ? sportTableLang.table['SPORT_TABLE.LBL_OS_OT1'] : sportTableLang.table['SPORT_TABLE.LBL_OS_OT'] }}</span>
                      </template>
                      <template v-else>
                        <div class="result-icon-wrap"><div :title="sportAllBetLang['ALL_BET.LBL_FT']" class="result-icon rs_jin_quan"></div></div>
                      </template>
                    </template>
                  </div>
                  <span data-v-9d87a3d9="" class="scroll-arrow" id="next-sn" v-if="sortedMatchEventList.sptid==15">
                      <i data-v-e826ac10="" data-v-9d87a3d9="" class="q-icon icon-arrow arrow-right c-icon set-color" aria-hidden="true" style="color:rgb(109, 114, 120); font-size: 10px;"> </i>
                  </span>
                  <template v-if="sortedMatchEventList.sptid==3">
                    <div data-v-9d87a3d9="" class="add-stage">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_SET'] }}</div>
                    <div data-v-9d87a3d9="" class="score">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_P'] }}</div>
                  </template>
                  <template v-else-if="sortedMatchEventList.rbinfo.score['S1'] && sortedMatchEventList.sptid==23">
                    <div data-v-9d87a3d9="" class="add-stage score">R</div>
                    <!-- <div data-v-9d87a3d9="" class="other-score">H</div> -->
                  </template>
                  <template v-else-if="sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21">
                    <div data-v-9d87a3d9="" class="add-stage">{{ sportTableLang.table['SPORT_TABLE.LBL_GAME'] }}</div>
                    <div data-v-9d87a3d9="" class="score">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                  </template>
                  <template v-else-if="sortedMatchEventList.rbinfo.score['S1'] && sortedMatchEventList.sptid==14">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                  </template>
                  <!-- <template v-else-if="sortedMatchEventList.sptid==20">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.LBL_TN_SET'] }}</div>
                  </template> -->
                  <!-- <template v-else-if="sortedMatchEventList.sptid==15">
                    <div data-v-9d87a3d9="" class="add-stage score">{{ sportTableLang.table['SPORT_TABLE.LBL_GAME'] }}</div>
                  </template> -->
                  <!-- <template v-else-if="sortedMatchEventList.sptid==7 || sortedMatchEventList.sptid==13">
                      <div data-v-9d87a3d9="" class="common-score score last">{{ sportTableLang.table['SPORT_TABLE.TOTAL_SCORE'] }}</div>
                  </template> -->
                </div>
              </div>
              <div data-v-9d87a3d9="" class="more-both">
                <div data-v-9d87a3d9="" class="both-item relative-position">
                  <!-- <div data-v-9d87a3d9="" class="wrap-round"></div>
                  <img data-v-9d87a3d9="" src="https://image.fwjaz.com/group1/M00/3E/C3/CgURtmbw0F6AcbYZAAARQ18Ne8I382.png" class="both-logo" data-team="Q" data-csid="undefined" style="opacity: 1;"> -->
                  <div data-v-9d87a3d9="" class="both-name ellipsis">
                    <span data-v-9d87a3d9="" class="ellipsis" v-html="sortedMatchEventList.tacapt"></span>
                  </div>
                  <div data-v-9d87a3d9="" class="scorll-handel">
                    <div data-v-9d87a3d9="" class="time-node is_details" :style="sortedMatchEventList.sptid==15 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'">
                      <template v-if="sortedMatchEventList.sptid==3 || sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21"> <!--  || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 -->
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-90337153="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scoa'] }}</span>
                          <span v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-90337153="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template>
                      </template>
                      <!-- <template v-else-if="sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23">
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]&&n!=sportColLength[sortedMatchEventList.sptid]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="sortedMatchEventList.rbinfo.st=='OT'" :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.rbinfo.score['OT']['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template>
                      </template> -->
                      <!-- <template v-else-if="sortedMatchEventList.sptid==13">
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="n<3&&sortedMatchEventList.rbinfo.score['S'+n]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="n>3&&sortedMatchEventList.rbinfo.score['S'+(n-1)]" :class="sortedMatchEventList.rbinfo.st=='S'+(n-1)?'current_color':''">{{ sortedMatchEventList.rbinfo.score['S'+(n-1)]['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="n==3&&sortedMatchEventList.rbinfo.score['S'+n]">{{ getScoreSet(sortedMatchEventList, 'A') }}</span>
                          <span data-v-9d87a3d9="" class="" v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scoa'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template>
                      </template> -->
                      <!-- <template v-else-if="sortedMatchEventList.sptid==19">
                        <template v-if="sortedMatchEventList.rbinfo.score">
                          <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                            <span v-if="sortedMatchEventList.rbinfo.score['H1']&&sortedMatchEventList.rbinfo.score['H1']['scoa']!=''">{{ sortedMatchEventList.rbinfo.score['H1']['scoa'] }}</span>
                            <span v-else>0</span>
                            <span v-if="sortedMatchEventList.rbinfo.score['H2']&&sortedMatchEventList.rbinfo.score['H2']['scoa']!=''">{{ sortedMatchEventList.rbinfo.score['H2']['scoa'] }}</span>
                            <span v-else>0</span>
                          </template>
                          <template v-else>
                            <span class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scoa'] }}</span>
                            <span>0</span>
                          </template>
                        </template>
                      </template> -->
                      <template v-else-if="sortedMatchEventList.sptid==23 || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 || sortedMatchEventList.sptid==19 || sortedMatchEventList.sptid==14">
                        <template v-if="sortedMatchEventList.rbinfo.score['S1'] && (sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23)">
                          <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                            <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]&&n!=sportColLength[sortedMatchEventList.sptid]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scoa'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-else-if="sortedMatchEventList.rbinfo.st=='OT'" :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.rbinfo.score['OT']['scoa'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-else></span>
                          </template>
                          <template v-else>
                            <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scoa'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                          </template>
                        </template>
                        <template v-else>
                          <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(sortedMatchEventList, 'A') }}</div>
                        </template>
                      </template>
                      <template v-else-if="sortedMatchEventList.sptid==13">
                        <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(sortedMatchEventList, 'A', true) }}</div>
                      </template>
                      <template v-else-if="sortedMatchEventList.sptid==7">
                          <div data-v-9d87a3d9="" class="score add-stage" :style="getScoreSet(sortedMatchEventList, 'A', true)!=0 ? 'width: 50px !important; text-align: right;':''">{{ getScoreSet(sortedMatchEventList, 'A', true) }}</div>
                      </template>
                    </div>
                    <div data-v-9d87a3d9="" :class="sportColLength[sortedMatchEventList.sptid]>5 && (sortedMatchEventList.sptid==23||sortedMatchEventList.sptid==15) ? 'score add-stage' : sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage'" v-if="sortedMatchEventList.sptid!=7&&sortedMatchEventList.sptid!=13&&sortedMatchEventList.sptid!=14&&sortedMatchEventList.sptid!=15&&sortedMatchEventList.sptid!=19&&sortedMatchEventList.sptid!=20&&sortedMatchEventList.sptid!=23">{{ getScoreSet(sortedMatchEventList, 'A') }}</div>
                    <div data-v-9d87a3d9="" :class="sportColLength[sortedMatchEventList.sptid]>5 && (sortedMatchEventList.sptid==23||sortedMatchEventList.sptid==15) ? 'score add-stage' : sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage'" v-else-if="sortedMatchEventList.rbinfo.score['S1']&&(sortedMatchEventList.sptid==14||sortedMatchEventList.sptid==23)">{{ getScoreSet(sortedMatchEventList, 'A') }}</div>
                    <template v-if="sortedMatchEventList.sptid==3">
                      <div data-v-9d87a3d9="" class="score" v-if="sortedMatchEventList.rbinfo.score['PT']">{{ sortedMatchEventList.rbinfo.score['PT']['scoa'] }}</div>
                      <div data-v-9d87a3d9="" class="score" v-else>0</div>
                    </template>
                    <!-- <template v-else-if="sortedMatchEventList.sptid==23">
                      <div data-v-9d87a3d9="" class="other-score">0</div>
                    </template> -->
                    <template v-else-if="sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(sortedMatchEventList, 'A', true) }}</div>
                    </template>
                    <!-- <template v-else-if="sortedMatchEventList.sptid==13">
                        <div data-v-9d87a3d9="" class="common-score score last">{{ getScoreSet(sortedMatchEventList, 'A', true) }}</div>
                    </template> -->
                  </div>
                </div>
                <div data-v-9d87a3d9="" class="both-item relative-position">
                  <!-- <div data-v-9d87a3d9="" class="wrap-round">
                    <span data-v-9d87a3d9="" class="round"></span>
                  </div>
                  <img data-v-9d87a3d9="" src="https://image.fwjaz.com/group1/M00/0C/EA/CgURt2BxOLSAVZ5XAAAnPKSAb2g165.png" class="both-logo" data-team="X" data-csid="undefined" style="opacity: 1;"> -->
                  <div data-v-9d87a3d9="" class="both-name ellipsis">
                    <span data-v-9d87a3d9="" class="ellipsis" v-html="sortedMatchEventList.tbcapt"></span>
                  </div>
                  <div data-v-9d87a3d9="" class="scorll-handel">
                    <div data-v-9d87a3d9="" class="time-node is_details" :style="sortedMatchEventList.sptid==15 ? 'margin: 0px 13px 0px 14px;':'margin: 0px;'">
                      <template v-if="sortedMatchEventList.sptid==3 || sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21"> <!--  || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 -->
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-90337153="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scob'] }}</span>
                          <span v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template>
                      </template>
                      <!-- <template v-else-if="sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23"> 
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]&&n!=sportColLength[sortedMatchEventList.sptid]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="sortedMatchEventList.rbinfo.st=='OT'" :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.rbinfo.score['OT']['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template>
                      </template> -->
                      <!-- <template v-else-if="sortedMatchEventList.sptid==13">
                        <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                          <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="n<3&&sortedMatchEventList.rbinfo.score['S'+n]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="n>3&&sortedMatchEventList.rbinfo.score['S'+(n-1)]" :class="sortedMatchEventList.rbinfo.st=='S'+(n-1)?'current_color':''">{{ sortedMatchEventList.rbinfo.score['S'+(n-1)]['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-else-if="n==3&&sortedMatchEventList.rbinfo.score['S'+n]">{{ getScoreSet(sortedMatchEventList, 'B') }}</span>
                          <span data-v-9d87a3d9="" class="" v-else></span>
                        </template>
                        <template v-else>
                          <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scob'] }}</span>
                          <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                        </template> 
                      </template>-->
                      <!-- <template v-else-if="sortedMatchEventList.sptid==19">
                        <template v-if="sortedMatchEventList.rbinfo.score">
                          <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                            <span v-if="sortedMatchEventList.rbinfo.score['H1']&&sortedMatchEventList.rbinfo.score['H1']['scob']!=''">{{ sortedMatchEventList.rbinfo.score['H1']['scob'] }}</span>
                            <span v-else>0</span>
                            <span v-if="sortedMatchEventList.rbinfo.score['H2']&&sortedMatchEventList.rbinfo.score['H2']['scob']!=''">{{ sortedMatchEventList.rbinfo.score['H2']['scob'] }}</span>
                            <span v-else>0</span>
                          </template>
                          <template v-else>
                            <span class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scob'] }}</span>
                            <span>0</span>
                          </template>
                        </template>
                      </template> -->
                      <template v-else-if="sortedMatchEventList.sptid==23 || sortedMatchEventList.sptid==20 || sortedMatchEventList.sptid==15 || sortedMatchEventList.sptid==19 || sortedMatchEventList.sptid==14">
                        <template v-if="sortedMatchEventList.rbinfo.score['S1'] && (sortedMatchEventList.sptid==14 || sortedMatchEventList.sptid==23)">
                          <template v-if="sortedMatchEventList.rbinfo.st!='NL'">
                            <span data-v-9d87a3d9="" class="" v-for="n in sportColLength[sortedMatchEventList.sptid]" :class="sortedMatchEventList.rbinfo.st=='S'+n?'current_color':''" v-if="sortedMatchEventList.rbinfo.score['S'+n]&&n!=sportColLength[sortedMatchEventList.sptid]">{{ sortedMatchEventList.rbinfo.score['S'+n]['scob'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-else-if="sortedMatchEventList.rbinfo.st=='OT'" :class="sortedMatchEventList.rbinfo.st=='OT'?'current_color':''">{{ sortedMatchEventList.rbinfo.score['OT']['scob'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-else></span>
                          </template>
                          <template v-else>
                            <span data-v-9d87a3d9="" class="current_color" v-if="sortedMatchEventList.rbinfo.st=='NL'">{{ sortedMatchEventList.rbinfo.score['NL']['scob'] }}</span>
                            <span data-v-9d87a3d9="" class="" v-for="n in (sportColLength[sortedMatchEventList.sptid]-1)"></span>
                          </template>
                        </template>
                        <template v-else>
                          <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(sortedMatchEventList, 'B') }}</div>
                        </template>
                      </template>
                      <template v-else-if="sortedMatchEventList.sptid==13">
                        <div data-v-9d87a3d9="" class="score add-stage">{{ getScoreSet(sortedMatchEventList, 'B', true) }}</div>
                      </template>
                      <template v-else-if="sortedMatchEventList.sptid==7">
                          <div data-v-9d87a3d9="" class="score add-stage" :style="getScoreSet(sortedMatchEventList, 'B', true)!=0 ? 'width: 50px !important; text-align: right;':''">{{ getScoreSet(sortedMatchEventList, 'B', true) }}</div>
                      </template>
                    </div>
                    <div data-v-9d87a3d9="" :class="sportColLength[sortedMatchEventList.sptid]>5 && (sortedMatchEventList.sptid==23||sortedMatchEventList.sptid==15) ? 'score add-stage' : sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage'" v-if="sortedMatchEventList.sptid!=7&&sortedMatchEventList.sptid!=13&&sortedMatchEventList.sptid!=14&&sortedMatchEventList.sptid!=15&&sortedMatchEventList.sptid!=19&&sortedMatchEventList.sptid!=20&&sortedMatchEventList.sptid!=23">{{ getScoreSet(sortedMatchEventList, 'B') }}</div>
                    <div data-v-9d87a3d9="" :class="sportColLength[sortedMatchEventList.sptid]>5 && (sortedMatchEventList.sptid==23||sortedMatchEventList.sptid==15) ? 'score add-stage' : sortedMatchEventList.sptid==14 ? 'score add-stage':'add-stage'" v-else-if="sortedMatchEventList.rbinfo.score['S1']&&(sortedMatchEventList.sptid==14||sortedMatchEventList.sptid==23)">{{ getScoreSet(sortedMatchEventList, 'B') }}</div>
                    <template v-if="sortedMatchEventList.sptid==3">
                      <div data-v-9d87a3d9="" class="score" v-if="sortedMatchEventList.rbinfo.score['PT']">{{ sortedMatchEventList.rbinfo.score['PT']['scob'] }}</div>
                      <div data-v-9d87a3d9="" class="score" v-else>0</div>
                    </template>
                    <!-- <template v-else-if="sortedMatchEventList.sptid==23">
                      <div data-v-9d87a3d9="" class="other-score">0</div>
                    </template> -->
                    <template v-else-if="sortedMatchEventList.sptid==12 || sortedMatchEventList.sptid==21">
                        <div data-v-9d87a3d9="" class="score">{{ getScoreSet(sortedMatchEventList, 'B', true) }}</div>
                    </template>
                    <!-- <template v-else-if="sortedMatchEventList.sptid==13">
                        <div data-v-9d87a3d9="" class="common-score score last">{{ getScoreSet(sortedMatchEventList, 'B', true) }}</div>
                    </template> -->
                  </div>
                </div>
              </div>
            </div>
            </template>
            <template v-else>
              <div class="before">
                <div class="content" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 15px 0px;">
                  <div class="team">
                    <div class="home">
                      <div class="team_name home-name allow-user-select" v-html="sortedMatchEventList.tacapt"></div>
                      <div class="img-wrap"></div>
                    </div>
                    <div class="match_time">
                      <div class="c-match-process text-center match_time-text vrow a-row">
                        <div class="jingcai" style="display: none;"></div>
                        <div class="process-name" style="display: none;">{{ lang.sportTableLang['SPORT_TABLE.LBL_NOT_STARTED'] }}</div>
                        <div class="c-match-date text-center date-wrap">
                          <template v-if="sortedMatchEventList.rbinfo">
                            <span style="min-width: 70px;font-size: 30px;">
                              {{sortedMatchEventList.rbinfo.scoa}} - {{sortedMatchEventList.rbinfo.scob}}<br>
                            </span>
                          </template>
                          
                          <span style="min-width: 70px;display: block;">
                            <template v-if="sortedMatchEventList.rbinfo && checkTimer(sortedMatchEventList) != ''">
                              <template v-if="sortedMatchEventList.sptid==1"> 
                                <template v-if="sortedMatchEventList.rbinfo.htst == '0'">{{ lang.sportTableLang['SPORT_TABLE.LBL_HT'] }}</template>
                                <template v-else-if="validateRBTimer(sortedMatchEventList) == '1'">{{ lang.sportTableLang['SPORT_TABLE.LBL_1HT'] }}</template>
                                <template v-else-if="validateRBTimer(sortedMatchEventList) == '2'">{{ lang.sportTableLang['SPORT_TABLE.LBL_2HT'] }}</template>
                                <template v-else> - </template>
                              </template>
                              <template v-else-if="sortedMatchEventList.sptid==2"> 
                                <template v-if="sortedMatchEventList.rbinfo.htst == '1'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q1'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '2'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q2'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '3'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q3'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '4'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q4'] }}</template>
                                <template v-else-if='sortedMatchEventList.rbinfo.htst == "5"'>{{ sportTableLang.table['SPORT_TABLE.LBL_1HT'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '6'">{{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '7'">{{ sportTableLang.table['SPORT_TABLE.LBL_2HT'] }}</template>
                                <template v-else-if="sortedMatchEventList.rbinfo.htst == '8'">{{ sportTableLang.table['SPORT_TABLE.LBL_OT'] }}</template>
                                <template v-else> - </template>
                              </template>
                            </template>
                            <template v-else>
                              <template v-if="selectedLang == 2 || selectedLang == 3">
                                <!--{{ moment(matchDateCheck(sortedMatchEventList.dt)).locale('cn').format("MMM Do") }} -->
                                {{ matchDateCheck(sortedMatchEventList.dt) | date('MM月DD日') }}
                              </template>
                              <template v-else>
                                {{ matchDateCheck(sortedMatchEventList.dt) | date('DD/MM') }}
                              </template>
                              <!-- <br> -->
                            </template>
                          </span>

                          <span style="min-width: 70px;display: block;">
                            <template v-if="sortedMatchEventList.rbinfo && checkTimer(sortedMatchEventList) != ''">
                              <template v-if="sortedMatchEventList.sptid==1"> 
                                <template v-if="sortedMatchEventList.rbinfo.htst == '0'">
                                </template>
                                <template v-else-if="validateRBTimer(sortedMatchEventList) == '1'">
                                  <template v-if="sortedMatchEventList.rbinfo.tlsec">{{ sortedMatchEventList | rb-timer('mm:ss') }}</template>
                                  <template v-else>0</template>'</template>
                                <template v-else-if="validateRBTimer(sortedMatchEventList) == '2'">
                                  {{ sortedMatchEventList | rb-timer('mm:ss') }}
                                </template>
                              </template>
                              <template v-else-if="sortedMatchEventList.sptid==2">
                                <template v-if="sortedMatchEventList.rbinfo.htst == '0'"></template>
                                <template v-else>
                                    {{ sortedMatchEventList | rb-timer }}
                                </template>
                              </template>
                            </template>
                            <template v-else>
                              {{ matchDateCheck(sortedMatchEventList.dt) | date('HH:mm') }}
                            </template>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="away">
                      <div class="img-wrap">
                        <!-- <img src="https://image.gredfged.com/group1/M00/12/70/CgURtmE22ViARqGwAAAahU51FMk689.png" alt="" class="team_logo" data-team="Y" data-csid="1" style="opacity: 1;"> -->
                      </div>
                      <div class="team_name away-name allow-user-select" v-html="sortedMatchEventList.tbcapt"></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="hide-btn" @click="showhide_Banner(false)">{{ sportAllBetLang['ALL_BET.LBL_HIDE'] }}</div>
        </div>
      </template>
      
      <!-- Right Menu -->
      <template v-else>
        <div class="c-video-ctrl">
          <div class="ctrl-wrap vrow items-center justify-between">
            <div class="unfold" :class="{'open':showRightBanner}" @click="showhidetvbanner()"></div>
            <div class="col-center vrow full-height">
              <div class="wrap_source relative-position line"  :class="{ active: (Object.keys(firstEvent).length==0 || livetvEveid<=0) }">
                <div class="vicon switch-icon" @click="closeTv()"   :class="{ active: (Object.keys(firstEvent).length==0 || livetvEveid<=0) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
              </div>
              
              <div class="wrap_source relative-position" v-if="tvIconFlag && firstEvent.rbstatus ==1 && firstEvent.ch>0"  :class="{ active: livetvEveid>0 }" >
                <div class="vicon video-icon" @click="startTv(firstEvent)"  :class="{ active: livetvEveid>0 }" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
              </div>
            </div>
            <div class="col-right">
              <div class="fold-btn" v-if="((open_RBMarket && selectedSport.sprtId=='N1') || !open_RBMarket) && show_Unfold && !selectedMatchAllBet && !simpleSport" @click="unfoldSc()">
                <span class="text"> {{ lang.sportTableLang['SPORT_TABLE.FOLD'] }}</span>
                <i size="12px" class="icon-arrow q-icon c-icon"></i>
              </div>
              <div style="display:none">
                <i aria-hidden="true" role="presentation" class="q-icon icon-big c-icon set-color" style="color:rgb(90, 96, 116);font-size: 14px;"></i>
              </div>
            </div>
          </div>
          <div class="vs-team-wrap relative-position">
            <div class="absolute-wrap" style="height: 100%;" data-mid="2265945">
              <div class="item current vs-team-container" v-if="Object.keys(firstEvent).length>0 && firstEvent.tacapt !=null && firstEvent.tbcapt !=null">
                <div class="line"></div>
                <span class="q-icon icon c-icon sport-img img36" style="width: 18px; height: 18px;" :class="getSportIcon(firstEvent.sptid)"></span>
                <div class="team-wrap ellipsis col allow-user-select">
                  <span v-html="firstEvent.tacapt"></span>
                  <span class="separate">v</span>
                  <span v-html="firstEvent.tbcapt"></span>
                </div>
                <div class="yb-icon-arrow" style="display: none;"></div>
              </div>
              <div class="scroll-area rule-scroll-area q-scrollarea">
                <div class="q-scrollarea__container scroll relative-position fit hide-scrollbar">
                  <div class="q-scrollarea__content absolute"></div>
                </div>
                <div aria-hidden="true" class="q-scrollarea__bar q-scrollarea__bar--v absolute-right q-scrollarea__bar--invisible"></div>
                <div aria-hidden="true" class="q-scrollarea__bar q-scrollarea__bar--h absolute-bottom q-scrollarea__bar--invisible"></div>
                <!--div aria-hidden="true" class="q-scrollarea__thumb q-scrollarea__thumb--v absolute-right q-scrollarea__thumb--invisible" style="top: 0px; height: 180px;"></div-->
                <div aria-hidden="true" class="q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom q-scrollarea__thumb--invisible" style="left: 0px; width: 416px;"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showRightBanner">
          <div class="wrap-info relative-position">
            <div class="c-match-video relative-position" :style="(Object.keys(firstEvent).length>0 && livetvEveLink!=''  && livetvEveid>0)? 'position: relative; width: 100%;':'height: 190px;' "> 
              <div class="right-icon">
                <i aria-hidden="true" @click="toggleTip()"  role="presentation" class="icon q-icon icon-tips3 c-icon set-color showTip" :style="{'color': !showTip ? 'rgb(255, 255, 255)' : 'rgb(255, 255, 255, 0.7)'}" style="font-size: 14px;"></i>
                <template v-if="showTip">
                  <div class="tip-content">
                    <div class="content-wrap relative-position">
                      <div class="yb-icon-triangle"></div>
                      <div class="content">{{ lang.sportTableLang['SPORT_TABLE.LIVE_NOTE'] }}</div>
                    </div>
                  </div>
                </template>
              </div>

              <div data-v-7eebf246="" class="load-data-wrap fit video-loading loading-wrap yb-flex-center relative-position" style="position: relative;width: 100%;overflow: hidden;padding-top: 56.25%;" v-if="Object.keys(firstEvent).length>0 && livetvEveLink!='' && livetvEveid>0">
                <template v-if="livetvEveLink=='error'">
                  <div style="margin-top: 10% !important; margin-bottom: -10% !important; border:none;position: absolute;top: 0;left: 0;bottom: 0;right: 0;width: 100%;height: 100%;border: none; text-align:center;">
                    <div class="err_img" style="height: 100px; width: 90px; margin: auto; "></div>
                      <span>{{ lang.sportTableLang['SPORT_TABLE.Stream_Error'] }}</span>
                  </div>
                </template>
                <template v-else>
                  <iframe id="livetv" style="border:none;position: absolute;top: 0;left: 0;bottom: 0;right: 0;width: 100%;height: 100%;border: none;"  :src="livetvEveLink" v-if="livetvEveLink!=true">{{ livetvEveLink }}</iframe>
                </template>

              </div>
              <div class="head-info" :class="getABetSport()" v-else-if="Object.keys(firstEvent).length>0" >
                <template v-if="firstEvent.rbinfo">
                  <div class="right_match_info match-time fit vrow flex-center">
                    <div class="football-after" v-if="firstEvent.sptid<3">
                      <div class="info-time">
                        <div class="match-date">
                          <div class="c-match-process text-center count_down vrow a-row" style="flex-flow: row;">
                            <div class="jingcai" style="display: none;"></div>
                            <div class="process-name">
                              <template v-if="firstEvent.rbinfo && checkTimer(firstEvent) != ''">
                                <template v-if="firstEvent.sptid==1"> 
                                  <template v-if="firstEvent.rbinfo.htst == '0'">
                                    {{ lang.sportTableLang['SPORT_TABLE.LBL_HT'] }}
                                  </template>
                                  <template v-else-if="validateRBTimer(firstEvent) == '1'">
                                    {{ lang.sportTableLang['SPORT_TABLE.LBL_1HT'] }}
                                  </template>
                                  <template v-else-if="validateRBTimer(firstEvent) == '2'">
                                    {{ lang.sportTableLang['SPORT_TABLE.LBL_2HT'] }}
                                  </template>
                                  <template v-else> - </template>
                                </template>
                                <template v-else-if="firstEvent.sptid==2"> 
                                  <template v-if="firstEvent.rbinfo.htst == '1'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q1'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '2'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q2'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '3'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q3'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '4'">{{ sportTableLang.table['SPORT_TABLE.LBL_Q4'] }}</template>
                                  <template v-else-if='firstEvent.rbinfo.htst == "5"'>{{ sportTableLang.table['SPORT_TABLE.LBL_1HT'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '6'">{{ sportTableLang.table['SPORT_TABLE.LBL_HT'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '7'">{{ sportTableLang.table['SPORT_TABLE.LBL_2HT'] }}</template>
                                  <template v-else-if="firstEvent.rbinfo.htst == '8'">{{ sportTableLang.table['SPORT_TABLE.LBL_OT'] }}</template>
                                  <template v-else> - </template>
                                </template>
                              </template>
                            </div>
                            <div class="c-match-date text-center date-wrap">
                              <div class="timer-layout relative-position">
                                <span class="timer-layout0">
                                  <template v-if="selectedLang == 2 || selectedLang == 3">
                                    {{ matchDateCheck(firstEvent.dt) | date('MM月DD日') }}
                                  </template>
                                  <template v-else>
                                    {{ matchDateCheck(firstEvent.dt) | date('DD/MM') }}
                                  </template>
                                </span>
                                <span class="timer-layout2">
                                  
                                  <template v-if="firstEvent.sptid==1"> 
                                    <template v-if="firstEvent.rbinfo.htst == '0'"></template>
                                    <template v-else-if="validateRBTimer(firstEvent) == '1'">
                                      <template v-if="firstEvent.rbinfo.tlsec">{{ firstEvent | rb-timer('mm:ss') }}</template>
                                      <template v-else>0</template>'</template>
                                    <template v-else-if="validateRBTimer(firstEvent) == '2'">
                                      <!-- <template v-if="selectedLang == 2 || selectedLang == 3"><br></template> -->
                                      {{ firstEvent | rb-timer('mm:ss') }}
                                    </template>
                                    <template v-else> 0 </template>
                                  </template>
                                  <template v-else-if="firstEvent.sptid==2">
                                    <template v-if="firstEvent.rbinfo.htst == '0'"></template>
                                    <template v-else-if="firstEvent.rbinfo.evetm">
                                        <!--template v-if="selectedLang==2 || selectedLang==3"><br></template-->
                                        <!-- <template v-if="!firstEvent.rbinfo.evetm">{{ firstEvent | rb-timer }}</template> -->
                                        {{ firstEvent | rb-timer }}
                                    </template>
                                  </template>
                                </span>
                              </div>
                              <span style="display: none;"></span>
                            </div>
                            <span class="icon-neutral q-icon c-icon" v-if="firstEvent.ha=='N'">
                              <span class="path1"></span>
                              <span class="path2"></span>
                            </span>
                          </div>
                        </div>
                        <div class="col"></div>
                        <div class="time-node">
                          <div class="result-icon-wrap" v-if="firstEvent.sptid==1 && displayConnerBooking('c',firstEvent,'a')!='-'">
                            <div class="result-icon rs_jiao_quan"  :title="sportAllBetLang['ALL_BET.LBL_CORNERCORNER']"></div>
                          </div>
                          <div class="result-icon-wrap" v-if="firstEvent.sptid==1 && displayConnerBooking('b',firstEvent,'a')!='-'">
                            <div class="result-icon yellow_card"  :title="sportAllBetLang['ALL_BET.LBL_YELLOWCARD']"></div>
                          </div>
                          <div class="result-icon-wrap" v-if="firstEvent.sptid==1">
                            <div class="result-icon red_card" :title="sportAllBetLang['ALL_BET.LBL_REDCARD']"></div>
                          </div>
                          <div class="result-icon-wrap"  v-if="firstEvent.sptid==1">
                            <div class="result-icon rs_jin_shang" :title="sportAllBetLang['ALL_BET.LBL_1HT']"></div>
                          </div>
                          <div class="result-icon-wrap">
                            <div class="result-icon rs_jin_quan"  :title="sportAllBetLang['ALL_BET.LBL_FT']"></div>
                          </div>
                          <div class="result-icon-wrap" style="display: none;">
                            <div class="result-icon add_time"></div>
                          </div>
                          <div class="result-icon-wrap" style="display: none;">
                            <i aria-hidden="true" role="presentation" class="result-icon q-icon icon-jia-dian c-icon" style="font-size: 15px;"></i>
                          </div>
                        </div>
                      </div>
                      <div class="info-both">
                        <div class="both-home">
                          <div class="wrap-logo">
                            <span class="ellipsis allow-user-select" style="font-weight: 400;" v-html="firstEvent.tacapt"></span>
                          </div>
                          <div class="info-data">
                            <span  v-if="firstEvent.sptid==1 && displayConnerBooking('c',firstEvent,'a')!='-'">{{ displayConnerBooking('c',firstEvent,'a') }}</span>
                            <span  v-if="firstEvent.sptid==1 && displayConnerBooking('b',firstEvent,'a')!='-'">{{ displayConnerBooking('b',firstEvent,'a') }}</span>
                            <span  v-if="firstEvent.sptid==1">{{ firstEvent.rbinfo.rca }}</span>
                            <span  v-if="firstEvent.sptid==1">
                              <template v-if="firstEvent.rbinfo.htscoa!=''">
                                {{ firstEvent.rbinfo.htscoa }}
                              </template>
                              <template v-else>
                                {{ firstEvent.rbinfo.scoa }}
                              </template>
                            </span>
                            <span class="mmp-active">{{ firstEvent.rbinfo.scoa }}</span>
                            <span class="" style="display: none;"></span>
                            <span class="" style="display: none;"></span>
                          </div>
                        </div>
                        <div class="both-away">
                          <div class="wrap-logo">
                            <span class="ellipsis allow-user-select" style="font-weight: 400;" v-html="firstEvent.tbcapt"></span>
                          </div>
                          <div class="info-data">
                            <span  v-if="firstEvent.sptid==1 && displayConnerBooking('c',firstEvent,'a')!='-'">{{ displayConnerBooking('c',firstEvent,'b') }}</span>
                            <span  v-if="firstEvent.sptid==1 && displayConnerBooking('b',firstEvent,'a')!='-'">{{ displayConnerBooking('b',firstEvent,'b') }}</span>
                            <span v-if="firstEvent.sptid==1" >{{ firstEvent.rbinfo.rcb }}</span>
                            <span v-if="firstEvent.sptid==1">
                              <template v-if="firstEvent.rbinfo.htscob!=''">
                                {{ firstEvent.rbinfo.htscob }}
                              </template>
                              <template v-else>
                                {{ firstEvent.rbinfo.scob }}
                              </template>
                            </span>
                            <span class="mmp-active">{{ firstEvent.rbinfo.scob }}</span>
                            <span class="" style="display: none;"></span>
                            <span class="" style="display: none;"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <osAllBetHeader :sportColLength="sportColLength" v-else></osAllBetHeader>
                  </div>
                </template>
                <template v-else>
                  <div class="right_match_info match-time fit vrow flex-center">
                    <div class="before">
                      <div class="content" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 15px 0px;">
                        <div class="team">
                          <div class="home">
                            <div class="team_name home-name allow-user-select" v-html="firstEvent.tacapt"></div>
                            <div class="img-wrap"></div>
                          </div>
                          <div class="match_time">
                            <div class="c-match-process text-center match_time-text vrow a-row">
                              <div class="jingcai" style="display: none;"></div>
                              <div class="process-name" style="display: none;">{{ lang.sportTableLang['SPORT_TABLE.LBL_NOT_STARTED'] }}</div>
                              <div class="c-match-date text-center date-wrap">
                                <span style="min-width: 70px;display:block;">
                                  <template v-if="selectedLang == 2 || selectedLang == 3">
                                   <!-- {{ moment(matchDateCheck(firstEvent.dt)).locale('cn').format("MMM Do") }} -->
                                    {{ matchDateCheck(firstEvent.dt) | date('MM月DD日') }}
                                  </template>
                                  <template v-else>
                                    {{ matchDateCheck(firstEvent.dt) | date('DD/MM') }}
                                  </template>
                                </span>
                                <span style="min-width: 60px;display:block;">
                                  {{ matchDateCheck(firstEvent.dt) | date('HH:mm') }}
                                </span>
                                <!--span>{{ firstEvent.dt | date('HH:mm') }}</span-->
                              </div>
                              
                              <span class="icon-neutral q-icon c-icon" v-if="firstEvent.ha=='N'">
                                <span class="path1"></span>
                                <span class="path2"></span>
                              </span>
                            </div>
                          </div>
                          <div class="away">
                            <div class="img-wrap"></div>
                            <div class="team_name away-name allow-user-select" v-html="firstEvent.tbcapt"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="head-info" v-else>
                <div data-v-7eebf246="" class="img-loading custom-format-img-loading" style="display: ;"></div>
                <div data-v-7eebf246="" class="loading-text">{{ lang.sportTableLang['SPORT_TABLE.LOADING'] }}</div>
              </div>  
            </div>
          </div>
        </div>
      </template>

      <div class="scroll-fixed-header wrap-tabs">
        <div class="tabs-panel relative-position">
          <div :id="'tab-wrap-list'+mode" class="tab-wrap fit relative-position" ref="tabWrapList" @mousedown="startDragHandler($event)" @mousemove="doDragHandler($event)" style="touch-action: none;">
            <div ref="itemWrapList" id="item-wrap-list" class="item-wrap relative-position" :style="getitemWrapStyle()">
              <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.all.key) }" @click="chooseBetTab(betTab.all)">
                {{ sportAllBetLang['ALL_BET.LBL_ALLBET'] }}
              </div>
              <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.hot.key) }" @click="chooseBetTab(betTab.hot)">
                {{ sportAllBetLang['ALL_BET.LBL_HOT'] }}
              </div>
              <template v-if="selectedBettype.tmpltId == '1'">
                <template v-if="checkBTExist('hdpou')">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.hdpou.key) }" @click="chooseBetTab(betTab.hdpou)">
                    {{ sportAllBetLang['ALL_BET.LBL_HDP_OU'] }}
                  </div>
                </template>
                <template v-if="checkBTExist('goals')">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.goals.key) }" @click="chooseBetTab(betTab.goals)">
                    {{ sportAllBetLang['ALL_BET.SUBHEADER_GOALS'] }}
                  </div>
                </template>
                <template v-if="checkBTExist('cs')">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.cs.key) }" @click="chooseBetTab(betTab.cs)">
                    {{ sportAllBetLang['ALL_BET.SUBHEADER_CS'] }}
                  </div>
                </template>
                <template v-if="checkFTExist()">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.ft.key) }" @click="chooseBetTab(betTab.ft)">
                    {{ sportAllBetLang['ALL_BET.LBL_FT'] }}
                  </div>
                </template>
                <template v-if="checkHTExist()">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.ht.key) }" @click="chooseBetTab(betTab.ht)">
                    {{ sportAllBetLang['ALL_BET.LBL_HT'] }}
                  </div>
                </template>
                <template v-if="checkSPExist()">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.special.key) }" @click="chooseBetTab(betTab.special)">
                    {{ sportAllBetLang['ALL_BET.LBL_SPECIALS'] }}
                  </div>
                </template>
                <template v-if="checkBTExist('other')">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.others.key) }" @click="chooseBetTab(betTab.others)">
                    {{ sportAllBetLang['ALL_BET.LBL_OTHERS'] }}
                  </div>
                </template>
                <template v-if="checkSpecialExist(betTab.booking.key)">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.booking.key) }" @click="chooseBetTab(betTab.booking)">
                    {{ sportAllBetLang['ALL_BET.LBL_BOOKING'] }}
                  </div>
                </template>
                <template v-if="checkSpecialExist(betTab.corner.key)">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.corner.key) }" @click="chooseBetTab(betTab.corner)">
                    {{ sportAllBetLang['ALL_BET.LBL_CORNER'] }}
                  </div>
                </template>

              </template>
              <template v-else-if="selectedBettype.tmpltId == '8'">
                <!-- Basketball -->
                <template v-if="selectedBettype.sprtId == 'G1'"></template>
                <!-- Tennis , Badminton, Volleyball -->
                <template v-else-if="otherSport1.includes(selectedBettype.sprtId)">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.sethdp.key) }" @click="chooseBetTab(betTab.sethdp)">
                    {{ sportAllBetLang['ALL_BET.LBL_SET'] }}
                  </div>
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.gamehdp.key) }" @click="chooseBetTab(betTab.gamehdp)">
                    {{ sportAllBetLang['ALL_BET.LBL_GAME'] }}
                  </div>
                </template>

                <template v-if="checkInningsExist('inning') && selectedBettype.sprtId == 'N23'">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.innings.key) }" @click="chooseBetTab(betTab.innings)">
                    {{ sportAllBetLang['ALL_BET.LBL_INNINGS'] }}
                  </div>
                </template>
                <template v-if="checkTeamExist('team') && selectedBettype.sprtId == 'N23'">
                  <div class="tab-item yb-flex-center" :class="{ active: (selected_Tab == betTab.team.key) }" @click="chooseBetTab(betTab.team)">
                    {{ sportAllBetLang['ALL_BET.LBL_TEAMS'] }}
                  </div>
                </template>
                <template v-else-if="selectedBettype.sprtId == 'N24'"></template>
                <!-- Snooker -->
                <!-- <template v-else-if="selectedBettype.sprtId == 'N15'"></template> -->
              </template>
            </div>
            <div class="left-btn btn" style="display: none;">
              <div class="yb-icon-arrow"></div>
            </div>
            <div class="right-btn btn" style="display: none;">
              <div class="yb-icon-arrow"></div>
            </div>
          </div>
        </div>
        <div class="vrow">
          <div class="right-icons" @click="foldopenAB()">
            <i aria-hidden="true" role="presentation" class="q-icon c-icon set-color" :class="{ 'icon-hide': foldopenAllBet, 'icon-open': !foldopenAllBet }"
              :title="foldopenAllBet?lang.sportTableLang['SPORT_TABLE.FOLD']:lang.sportTableLang['SPORT_TABLE.OPEN']"
              style="color: rgb(90, 96, 116); font-size: 14px;" v-if="mode=='ab'"></i>
              <i aria-hidden="true" role="presentation" class="q-icon c-icon set-color" :class="{ 'icon-hide': foldopenFirstEvent, 'icon-open': !foldopenFirstEvent }"
              :title="foldopenFirstEvent?lang.sportTableLang['SPORT_TABLE.FOLD']:lang.sportTableLang['SPORT_TABLE.OPEN']"
              style="color: rgb(90, 96, 116); font-size: 14px;" v-if="mode!='ab'"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import EventBus from '../../events/event-bus'
import DateFilter from '@/vue/filters/date'
import moment from 'moment'
import 'moment/locale/zh-cn'

// import allBetComponent from './allBet/all-bet'
import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'
import osAllBetHeader from './osAllBetHeader'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    // allBetComponent,
    osAllBetHeader
  },
  props: {
    mode: null,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      'matchAllBet',
      'sortedMatchEventList',
      'market',
      'tvIconFlag',
      'allBetReloading',
      'selectedShow',
      'selectedMarket',
      'selectedBettype',
      'selectedAllBetNew',
      'selected_AllBetTab',
      'selectedSport',
      'selectedMatchAllBet',
      'foldopenAllBet',
      'foldopenFirstEvent',
      'show_Unfold',
      'showRightBanner',
      'firstEvent',
      'livetv',
      'open_RBMarket',
      'timeZone',
      'betForm',
      'simpleSport',
      'liveSchedule',
      'liveMatch',
      'isOpenTv',
    ]),
    selected_Tab: {
      get() {
        if(this.mode=='ab'){
          return this.$store.getters.selected_AllBetTab.ab;
        }else{
          return this.$store.getters.selected_AllBetTab.firstEvent;
        }
      }
    },
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    livetvEveLink: {
      get() {
        return this.$store.getters.livetv.link;
      }
    },
  },
  watch: {
    'livetvEveid': {
      handler(val, oldVal) {
        if(val != oldVal) {
          this.tvIsOn = true
        }
      },
      deep: true,
      immediate: true,
    },
    'showhideBanner': {
      handler(val, oldVal) {
        this.allBet_mContent()
      },
      deep: true,
      immediate: true,
    },
    'firstEvent': {
      handler(val, oldVal) {

        if(Object.keys(val).length>0 && !_.isUndefined(oldVal) && val.eveid!=oldVal.eveid){

          this.itemWrapLeft = 0
          this.eleScrollLeft = 0
          document.getElementById("tab-wrap-list"+this.mode).scrollLeft = 0
          // var arr = { 'firstEvent': 'hot' }
          var arr = { 'firstEvent': 'all' }
          this.$store.commit('SELECTED_ALLBETTAB', arr)

          if(this.$store.getters.selectedBettype.betTypId=='5'){  //mulp
            this.$nextTick(() => {
              let allBetparent = document.querySelectorAll('#'+this.mode+'allBetGroup'+val.eveid);
              allBetparent.forEach((childAllBet , indexAb)=>{
                var allBetchk = childAllBet.querySelector('.c-bet-item.active')
                if(allBetchk!=null){
                  allBetchk.classList.remove("active");
                }
              })

              // check selected odds based on betform
              if(this.betForm.length > 0){
                var bForm = this.betForm
                bForm.forEach((dt , index)=>{
                  if(dt.eveid==val.eveid){
                    $("[id="+dt.uniqueId+"]").closest('.c-bet-item').addClass('active')
                  }
                })
              }
              
            })
          }
        }
      },
      deep: true,
      immediate: true,
    },

  },
  data() {
    return {
      dragging: false,
      selectedLang: window._langid,
      lang: window.lang,
      fT: ['2', '3'],
      hT: ['2', '4'],
      showhideAll: true,
      otherSport1: ['N3', 'N12', 'N21'],  //tennis,badminton,volleyball
      betTab: {
        hot: {
          key: 'hot',
          value: true,
          flag: true,
        },
        hdpou: {
          key: 'hdpou',
          value: [1,2,4,32,46,48], //bettype in allbet mixin
          rbvalue: [8,9,11,33,47,49],
          flag: true,
        },
        goals: {
          key: 'goals',
          value: [2, 3, 5], //bettype in allBet mixin
          rbvalue: [18, 9, 10],
          flag: true,
        },
        cs: {
          key: 'cs',
          value: [7], //bettype in allBet mixin
          rbvalue: [16],
          flag: true,
        },
        ft: {
          key: 'ft',
          value: [1], //plytyp in allbet mixin
          rbvalue: [8],
          flag: true,
        },
        ht: {
          key: 'ht',  //first half
          value: [2], //plytyp in allbet mixin
          flag: true,
        },
        sh: {
          key: 'sh',  //2nd half
          value: [19], //plytyp in allbet mixin
          flag: true,
        },
        others: {
          key: 'others',
          value: true,
          flag: true,
        },
        special: {
          key: 'special',
          value: true,
          flag: true,
        },
        other: {
          key: 'other',
          value: [21,34,28,30],
          rbvalue: [27,29,35,31],
          flag: true,
        },
        scrMarket: {
          key: 'scrMarket',
          value: [2, 3, 5, 7, 9, 10], //bettype in allBet mixin
          flag: true,
        },
        sethdp: {
          key: 'set',
          value: [3, 7, 8, 9, 10, 11, 12],
          rbvalue: [27,29,35,31],  //rbettype in allBet mixin
          flag: true,
        },
        gamehdp: {
          key: 'game',
          value: [6],
          flag: true,
        },
        pointhdp: {
          key: 'point',
          value: [4],
          flag: true,
        },
        all: {
          key: 'all',
          value: true,
          flag: true,
        },
        innings: {
          key: 'innings',
          value: [allBetMixin.data().first5InningsPlayType,
          allBetMixin.data().first3InningsPlayType,
          allBetMixin.data().firstInningsPlayType,
          allBetMixin.data().secondInningsPlayType,
          allBetMixin.data().thirdInningsPlayType,
          allBetMixin.data().fourthInningsPlayType,
          allBetMixin.data().fifthInningsPlayType,
          allBetMixin.data().sixthInningsPlayType,
          allBetMixin.data().seventhInningsPlayType,
          allBetMixin.data().eightthInningsPlayType,
          allBetMixin.data().nineInningsPlayType,
          allBetMixin.data().OTPlayType],
          flag: true,
        },
        team: {
          key: 'team',
          value: [allBetMixin.data().htrBetType,allBetMixin.data().atrBetType, allBetMixin.data().rhtrBetType,allBetMixin.data().ratrBetType],
          flag: true,
        },
        booking: {
          key: 'booking',
          value: ['7b','10a','23a'],
          flag: true,
        },
        corner: {
          key: 'corner',
          value: ['7a','9a','22a'],
          flag: true,
        },
      },
      showhideBanner: true,
      showTip: false,
      mContentPadding: '',
      reloading: false,
      bannerSize: 190,
      itemWrapLeft: 0,
      eleScrollLeft: 0,
      clientX: 0,
      moment: moment,
      token: window.token,

      timerSeconds: 60,
      earlyTimer: 60,
      rbTimer: 15,
      todayTimer: 30,
      reconnectTimerSeconds: 5,
      timerId: null,
      reconnectTimerId: null,
      tvIsOn: false,
      sportColLength:{
        '3': 6,
        '21': 5,
        '12': 3,
        '23': 10,
        '14': 4,
        '19': 2,
        '13': 5,
        '20': 6,
        '15': 35,
      },
    }
  },
  methods: {
    displayConnerBooking(cb,event,team){
      let disSC='-';
      if(event.sp_rbinfo!=undefined){
        _.forEach(event.sp_rbinfo, function (data, key) {
          if(data.r==cb){
            disSC = team=='a' ? data.scoa:data.scob;
          }
        });
      }
      if(cb=='b'){
        if(event.rbinfo!=undefined && disSC!='-'){
          let redCardPoint = team=='a' ? event.rbinfo.rca: event.rbinfo.rcb;
          if(redCardPoint>0){
            disSC=disSC - (redCardPoint*2);
          }
          if(disSC<0){
            disSC='-';
          }
        }else{
          disSC='-';
        }
      }
      return disSC;
    },
    matchDateCheck(date){
      return moment.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss")
      },
    closeTv(){
      let tvlinkArray={};
      tvlinkArray.link = null
      tvlinkArray.eveid = null
      this.$store.commit('LIVETV', tvlinkArray);
    },
    startTv(event){    
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect) {
          $('.login-redirect-dialog').show();
        }
        return false
      }
      this.loading = true;    
      this.$ajax({
        url: _baseUrl + '/livetv',
        type: 'post',
        data: {
          chlid: event.ch,
          eventid: event.eveid,
          league: event.lgeid,
          tacap: event.tacapt,
          tbcap: event.tbcapt
        }
      }).then(response => {
        this.loading = false;    
        let tvlinkArray={};
        tvlinkArray.link = response
        tvlinkArray.eveid = event.eveid
        this.$store.commit('LIVETV', tvlinkArray);
      })
          
    },
    checkStart(end){
      // var startTime = new moment().zone("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var startTime = new moment().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
      var endTime = moment(end);
      var difference = endTime.diff(moment(startTime), 'minutes')
      if (difference >= 0) {
        return difference;
      }
      return 10000
    },
    removeDragHandler(){
      window.addEventListener('mouseup', this.stopDragHandler);
      window.addEventListener('touchend', this.stopDragHandler);
    },
    doDragHandler(e){
      if (this.dragging) {
        var drag = document.getElementById("tab-wrap-list"+this.mode)
        let dx;
        if (e.type === 'mousemove') {
          dx = e.clientX - this.clientX;
        } else if (e.type === 'touchmove') {
          dx = e.touches[0].clientX - this.clientX;
        }
        drag.scrollLeft= this.eleScrollLeft - dx
      }
    },
    startDragHandler(e){
      if (e.type === 'mousedown') {
        this.clientX = e.clientX;
      } else if (e.type === 'touchstart') {
        this.clientX = e.touches[0].clientX;
      }
      this.dragging = true;
      var drag = document.getElementById("tab-wrap-list"+this.mode)
      this.eleScrollLeft = drag.scrollLeft
    },
    stopDragHandler(){
      this.dragging = false;
    },
    toggleTip(){
      this.showTip = !this.showTip
    },
    getitemWrapStyle(){
      return 'left:'+ this.itemWrapLeft +'px;'
    },
    showhidetvbanner(){
      this.$store.commit('SHOWRIGHTBANNER', !this.$store.getters.showRightBanner)
    },
    unfoldSc(){
      this.$store.commit('SHOW_FOLD', true)
      this.$store.commit('SHOW_UNFOLD', false)
      this.$store.commit('UNFOLD_ALLSC', true)
      var element = document.getElementById('AllBetScrollfirstEvent');
      element.classList.add('hide');
      $('.c-site-header .header-item.item2').css('z-index', '48');
    },
    checkFTExist(){
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      if(eveList.od && eveList.od[this.ftPlyType] && (eveList.sptid == 1 || eveList.sptid == 13)){
        exist = true
      }
      return exist
    },
    checkHTExist(){
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      if(eveList.od && eveList.od[this.firstHtPlyType] && (eveList.sptid == 1 || eveList.sptid == 13)){
        exist = true
      }
      if(eveList.od && eveList.od[this.SecondHtPlyType] && (eveList.sptid == 1)){
        exist = true
      }
      return exist
    },
    checkSPExist(){
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      if(eveList.sp){
        exist = true
      }
      let specialBetTypes = [this.nogBetType, this.onex2ouBetType, this.onex2bttsBetType, this.ouoeBetType, this.oubttsBetType, this.ouftsBetType, this.onex2ftsBetType, this.dbchouBetType, this.dbchbttsBetType, this.dbchftsBetType]
      if(!exist) {
        _.forEach(eveList.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(k, specialBetTypes) > -1) {
              exist = true
            }
          })
        })
      }
      return exist
    },
    checkSpecialExist(type){
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      let betTab = this.betTab
      if(eveList.sp){
          $.each(eveList.sp, function (key, value) {
            if(type == betTab.corner.key && value.od) {
              // if (value.sbid.startsWith("9a") || value.sbid.startsWith("22a")) {
              const prefixes = betTab.corner.value;
              if (prefixes.some(prefix => value.sbid.startsWith(prefix))) {
                exist = true
                return false
              }
            } else if(type == betTab.booking.key  && value.od){
              // if (value.sbid.startsWith("10a") || value.sbid.startsWith("23a")) {
              const prefixes = betTab.booking.value;
              if (prefixes.some(prefix => value.sbid.startsWith(prefix))) {
                exist = true
                return false
              }
            } else {
              return false
            }
					});
      }
      return exist
    },
    checkBTExist(BTkey) {
      let vue = this
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      let btArray = (eveList.rbinfo) ? vue.betTab[BTkey].rbvalue : vue.betTab[BTkey].value

      _.forEach(eveList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray(parseInt(k), btArray) > -1) {
            exist = true
          }
        })
      })
      return exist
    },
    checkInningsExist(){
      let vue = this
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent

      let ptArray = vue.betTab['innings'].value
      _.forEach(eveList.od, function (data, key) {
        if ($.inArray((key).toString(), ptArray) > -1) {
          exist = true
        }
      })
      return exist
    },
    checkTeamExist(){
      let vue = this
      let exist = false
      let eveList = (this.mode=='ab') ? this.sortedMatchEventList : this.firstEvent
      let btArray = vue.betTab['team'].value

      _.forEach(eveList.od, function (data, key) {
        _.forEach(data, function (val, k) {
          if ($.inArray((k).toString(), btArray) > -1) {
            exist = true
          }
        })
      })
      
      return exist
    },
    allBet_mContent(){
      var a = 76
      var b = (this.showhideBanner) ? a + this.bannerSize : a

      this.mContentPadding = 'padding-top: '+b+'px;'
    },
    showhide_Banner(val){
      this.showhideBanner = val
      EventBus.$emit('hideScoreBoard',val);
      // this.allBet_mContent()
    },
    getABetSport() {
      var sprt =  this.mode=='ab' ? 'N'+this.$store.getters.sortedMatchEventList.sptid : 'N'+this.$store.getters.firstEvent.sptid
      var sprt = this.$store.getters.selectedBettype.sprtId
      if(this.mode=='ab'  && !_.isUndefined(this.$store.getters.sortedMatchEventList.sptid)){
        sprt = 'N'+this.$store.getters.sortedMatchEventList.sptid
      }else if(this.mode!='ab'  && !_.isUndefined(this.$store.getters.firstEvent.sptid)){
        sprt = 'N'+this.$store.getters.firstEvent.sptid  
      }
      if(sprt == 'G98'){
        var spid = 'N'+this.$store.getters.firstEvent.sptid
        return 'allBet'+spid
      }else{
        return 'allBet'+sprt
      }
    },
    foldopenAB() {
      if(this.mode=='ab'){
        this.$store.commit('FOLDOPEN_ALLBET', !this.$store.getters.foldopenAllBet)
      }else{
        this.$store.commit('FOLDOPEN_FIRSTEVENT', !this.$store.getters.foldopenFirstEvent)
      }
    },
    showhideMain() {
      this.showhideAll = (this.showhideAll) ? false : true;
      this.$set(this.sortedMatchEventList, 'hide', !this.sortedMatchEventList.hide)
    },
    chooseBetTab(betTab) {
      if (betTab.flag) {
        let BETTAB_value={};
        if(this.mode=='ab'){
          BETTAB_value.ab=betTab.key;
        }else{
          BETTAB_value.firstEvent=betTab.key;
        }

        $('#AllBet'+this.mode).getNiceScroll().remove();
        
        $('#AllBet'+this.mode).niceScroll({  
          horizrailenabled: false,
          autohidemode: false, 
          scrollbarid:'AllBetScroll'+this.mode,
          cursorborder: "0px solid #fff", 
          zindex:48,
          railoffset: { left:10 },
        }),
        this.$store.commit('SELECTED_ALLBETTAB', BETTAB_value)
      }
    },
    switchAllBetTab(id) {
      $('.moreBetTypeNav-Item').removeClass('active');
      $(id).addClass('active');
    },
    reloadTable(token_val = '') {
      this.oddsReload = true
      // this.clearTimer()
      EventBus.$emit('templateChange', this.oddsReload);
      // this.reloadingPer = '25%';
      var dispatchName = 'getSportOdds'
      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        dispatchName = 'getSportOutrightOdds'
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8
      }
      // this.reloadingPer = '80%';
      this.$store.dispatch(dispatchName, {
        token: token_val,
        showfavorite: (this.$store.getters.showFavEvents && dispatchName == 'getSportOdds')? true:false,
        callback: ((res) => {
          if (res.events) {
            // this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
            // this.startTimer()
            // clearInterval(this.reconnectTimerId)
            this.reconnectTimerId = null
            _.forEach(res.events, function (val, key) {
              _.forEach(val, function (v, k) {
                var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse')
                if (showAllBet) {
                  $('#moreExpand' + v.eveid).addClass('icon-moreExpand')
                  $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse')
                  $('#moreBets' + v.eveid).css("display", "none");
                }
              })
            })
          } else {
            this.reconnectTimerSeconds = 5;
            if (this.reconnectTimerId == null) {
              this.reconnectTimerId = setInterval(() => {
                if (this.reconnectTimerSeconds - 1 < 0) {
                  this.reloadTable()
                } else {
                  this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (this.showFavEvents) {
            this.$store.dispatch('getLaugueList', (function (res) {
              this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
              this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
            }).bind(this))
          }
          this.reloading = false
          this.oddsReload = false
          EventBus.$emit('templateChange', this.oddsReload);
          // this.refreshScroll()

          this.$store.commit('PARLAY_SELECTED', { update: false })
        }).bind(this)
      })
    },
    backToMain() {
      EventBus.$emit('sportTableReloading', true)
      this.reloadTable()
      this.$store.commit('SELECTED_MATCHALLBET', false)
      $('#AllBet'+this.mode).getNiceScroll().remove();
      $('#AllBet'+this.mode).remove();
    },
    clearTimer() {
      clearInterval(this.timerId)
      this.timerId = null
    },
    getMarketTimer(selMarket) {
			if (this.$store.getters.open_RBMarket) {
				return this.rbTimer
			} else if (selMarket == this.$store.getters.market.earlyMarket.key) {
				return this.earlyTimer    
			} else if (selMarket == this.$store.getters.market.tdyMarket.key) {
				return this.todayTimer
			}
		},
    startAllBetTimer() {
			if (this.timerId == null) {
				this.timerId = setInterval(() => {
				if (this.timerSeconds - 1 < 0) {
					// this.reloadTable(token.arr_1)
					this.refreshTbl(token.arr_1)
				} else {
					this.timerSeconds -= 1;
				}
				}, 1000);
			}
		},
    refreshTbl(token_val) {
      $('#tblRefresh').addClass('loading-static-animation')
      this.reloading = (token_val == token.arr_1 || token_val == token.arr_5) ? false : true
      if (this.selectedMatchAllBet) {
        this.reloadAllBetTable(token_val)
      }
    },
    reloadAllBetTable(token_val = '') {
			if (token_val == '') {
				token_val = token.arr_5
			}
      var getEvent = ''
      var rbSta = ''
      var startTv = 0
      this.clearTimer()
      if(this.$store.getters.liveSchedule && this.$store.getters.liveMatch != null){
      	getEvent = this.$store.getters.liveMatch
        rbSta = this.$store.getters.liveMatch.rbstatus
        startTv = this.$store.getters.isOpenTv 
      }else{
        getEvent = this.$store.getters.sortedMatchEventList
        rbSta = this.$store.getters.sortedMatchEventList.rbstatus
      }
      this.$store.dispatch('getMatchAllBet', {
        event: getEvent,
        isRB: (rbSta==1) ? true : false,
        // token: token.arr_8,
        token: token.arr_8,
        loadTemplate: startTv,  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
        reload: true,
        notLoadTV:true
      })
      
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

      this.startAllBetTimer()
			// this.reloadingPer = '25%';
      /*
			this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList)

			// this.reloadingPer = '80%';
			this.$store.dispatch('getSportAllBet', {
				token: token_val,
				inAllBet: true,
				event: this.$store.getters.sortedMatchEventList,
				callback: ((res) => {
				this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

				this.startAllBetTimer()
				this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)

				this.$nextTick(() => {
					EventBus.$emit('diffOdd', this.cloneEventAllBet)
				})
				this.reloading = false
				}).bind(this)
			})*/
		},
    refreshRightScoreBoard(token_val = '') {
      if(this.$store.getters.firstEvent && (Object.keys(this.$store.getters.firstEvent).length > 0 || this.$store.getters.firstEvent.length > 0)) {
        this.$store.dispatch('getMatchAllBet', {
          event: this.$store.getters.firstEvent,
          isRB: (this.$store.getters.firstEvent.rbstatus==1) ? true : false,
          token: token.arr_8,
          loadTemplate: (this.livetvEveLink!='' && this.livetvEveid>0)? 2:1,  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
          notLoadTV: (this.livetvEveLink!='' && this.livetvEveid>0)?true:false,
          reload: true
        })
      }
		},
    checkTimer(event) {
      return this.$options.filters.checkTimer(event)
    },
    getSportIcon(sptid){
      // var sprt = this.$store.getters.selectedBettype.sprtId
      return 'N'+sptid+'_R'
    },
    getScoreSet(event, team, total=false){
      let teamA = 0
      let teamB = 0

      _.forEach(event.rbinfo.score, function (data, key) {
        if(event.sptid==3){
          if(key == 'SH'){
            teamA = parseInt(data.scoa)
            teamB = parseInt(data.scob)
          }
          /*if(key != 'PT' && key != event.rbinfo.st){
            if(data.scoa > data.scob){
              teamA += 1
            }else if(data.scoa < data.scob){
              teamB += 1
            }
          }*/
        }else if(event.sptid==23){
          // if(key != 'OT' && key != event.rbinfo.st){
            // teamA += parseInt(data.scoa)
            // teamB += parseInt(data.scob)
            if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
            }
          // }
        }else if(event.sptid==14){
          // if(key != 'OT'){
            // teamA += parseInt(data.scoa)
            // teamB += parseInt(data.scob)
            if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
            }
          // }
        }else if(event.sptid==12||event.sptid==21){
          if(total){
            // teamA += parseInt(data.scoa)
            // teamB += parseInt(data.scob)
            if(key == 'PT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
            }
          }else{
            if(key == 'SH'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
            }/*if(key != event.rbinfo.st){
              if(data.scoa > data.scob){
                teamA += 1
              }else if(data.scoa < data.scob){
                teamB += 1
              }
            }*/
          }
        }else if(event.sptid==20||event.sptid==15){
          /*if(key != event.rbinfo.st){
            if(data.scoa > data.scob){
              teamA += 1
            }else if(data.scoa < data.scob){
              teamB += 1
            }
          }*/
          if(key == 'FT'){
              teamA = parseInt(data.scoa)
              teamB = parseInt(data.scob)
          }
        }else if(event.sptid==13){
          if(total){
            // teamA += parseInt(data.scoa)
            // teamB += parseInt(data.scob)
            if(key == 'FT'){
                teamA = parseInt(data.scoa)
                teamB = parseInt(data.scob)
            }
          // }else{
          //   if(key == 'S1' || key == 'S2'){
          //     teamA += parseInt(data.scoa)
          //     teamB += parseInt(data.scob)
          //   }
          }
        }else if(event.sptid==7 || event.sptid == 19){
          // teamA = data.scoa
          // teamB = data.scob  
          if(key == 'FT'){
              teamA = data.scoa
              teamB = data.scob
          }
        }
      })

      return team == 'A' ? teamA : teamB
    },
    activeRbScoreBoard(){
        
      const $container = $('.time-node.mini');
      const $next = $('#next');
      const $prev = $('#prev');
      const itemWidth = 35;

      let isAnimating = false;

      $('.icon-arrow').hover(
        function () {
          $(this).css('color', 'rgb(255, 112, 0)');
        },
        function () {
          $(this).css('color', 'rgb(109, 114, 120)');
        }
      );

      $next.off('click').on('click', () => {
        if (isAnimating) return;
        isAnimating = true;

        $container.animate(
          { scrollLeft: $container.scrollLeft() + itemWidth },
          300,
          () => {
            isAnimating = false;
            updateArrowVisibility();
          }
        );
      });

      $prev.off('click').on('click', () => {
        if (isAnimating) return;
        isAnimating = true;

        $container.animate(
          { scrollLeft: $container.scrollLeft() - itemWidth },
          300,
          () => {
            isAnimating = false;
            updateArrowVisibility();
          }
        );
      });

      function updateArrowVisibility() {
        const scrollLeft = $container.scrollLeft();
        if(scrollLeft!=undefined){
          const maxScrollLeft = $container[0].scrollWidth - $container.outerWidth();
          
          if(scrollLeft > 0){
            $('#prev .arrow-left').css('display', 'block');
          }else{
            $('#prev .arrow-left').css('display', 'none');
          }
          if(scrollLeft < maxScrollLeft){
            $('#next .arrow-right').css('display', 'block');
          }else{
            $('#next .arrow-right').css('display', 'none');
          }
        }
      }

      updateArrowVisibility();

      $container.on('scroll', () => {
        if (!isAnimating) updateArrowVisibility();
      });

    },
    activeAllBetOsScoreBoard(event){
      this.$nextTick(()=>{
        const $container = $('.time-node.is_details');
        const $next = $('#next-sn');
        const $prev = $('#prev-sn');
        const itemWidth = 35;

        let isAnimating = false; 
        
        
        $('.is_details .icon-arrow').hover(
          function () {
            $(this).css('color', 'rgb(255, 112, 0)');
          },
          function () {
            $(this).css('color', 'rgb(109, 114, 120)');
          }
        );

    
        $next.off('click').on('click', () => {
          if (isAnimating) return;
          isAnimating = true;
          
          $container.animate(
            { scrollLeft: $container.scrollLeft() + itemWidth },
            300,
            () => {
              isAnimating = false;
              updateArrowVisibility();
            }
          );
        });

        $prev.off('click').on('click', () => {
          if (isAnimating) return;
          isAnimating = true;
          
          $container.animate(
            { scrollLeft: $container.scrollLeft() - itemWidth },
            300,
            () => {
              isAnimating = false;
              updateArrowVisibility();
            }
          );
        });

        function updateArrowVisibility() {
          const scrollLeft = $container.scrollLeft();
          if(scrollLeft!=undefined){
            const maxScrollLeft = $container[0].scrollWidth - $container.outerWidth();

            if(scrollLeft > 0){
              $('#prev-sn .arrow-left').css('display', 'block');
            }else{
              $('#prev-sn .arrow-left').css('display', 'none');
            }
            if(scrollLeft < maxScrollLeft){
              $('#next-sn .arrow-right').css('display', 'block');
            }else{
              $('#next-sn .arrow-right').css('display', 'none');
            }
          }
        }

        updateArrowVisibility();

        $container.on('scroll', () => {
          if (!isAnimating) updateArrowVisibility();
        });
      })
    }
  },
  mounted () {
    this.allBet_mContent()
    this.removeDragHandler()
    this.$refs.tabWrapList.addEventListener('mousedown', this.startDragHandler);
    this.$refs.tabWrapList.addEventListener('touchstart', this.startDragHandler);
    window.addEventListener('mousemove', this.doDragHandler);
    window.addEventListener('touchmove', this.doDragHandler);
    let Vue=this
    EventBus.$on('refreshAllbetTable', ((params) => {
      if (this.selectedMatchAllBet) {
        this.refreshTbl(params.token) ;
      }
      
    }).bind(this))

    EventBus.$on('refreshRightScoreBoard', ((params) => {
      this.refreshRightScoreBoard(params.token);
    }).bind(this))

    EventBus.$on('activeRbScoreBoard', (() => {
      this.activeRbScoreBoard()
    }).bind(this))

    EventBus.$on('activeAllBetOsScoreBoard', ((params) => {
      this.activeAllBetOsScoreBoard(params)
    }).bind(this))

    $(document).on('click', function (e) {
      if(Vue.showTip){
          if ($(e.target).closest(".tip-content").length === 0 && $(e.target).closest(".showTip").length === 0) {
              Vue.showTip=false;
          }
      }
    });
  },
  beforeMount(){
    if(this.mode=='ab'){
      let BETTAB_value={};
      if(this.mode=='ab'){
        // BETTAB_value.ab=this.betTab.hot.key;
        BETTAB_value.ab=this.betTab.all.key;

      }else{
        // BETTAB_value.firstEvent=this.betTab.hot.key;
        BETTAB_value.firstEvent=this.betTab.all.key;

      }
      this.$store.commit('SELECTED_ALLBETTAB', BETTAB_value)
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
      this.startAllBetTimer()
      if(this.$refs.tabWrapList){
        this.$refs.tabWrapList.removeEventListener('mousedown', this.startDragHandler);
        this.$refs.tabWrapList.removeEventListener('touchstart', this.startDragHandler);
      }
      window.removeEventListener('mousemove', this.doDragHandler);
      window.removeEventListener('touchmove', this.doDragHandler);
      window.removeEventListener('mouseup', this.stopDragHandler);
      window.removeEventListener('touchend', this.stopDragHandler);

    }
  },
  updated() {
    if(this.tvIsOn) {
      this.tvIsOn = false
      EventBus.$emit('rightScoreBoard',true);
    }
    this.activeRbScoreBoard()
  },
  destroyed () {
    // this.closeTv();
    this.clearTimer();
    this.removeDragHandler()
    EventBus.$off('templateChange')
    EventBus.$off('sportTableReloading')
    EventBus.$off('refreshAllbetTable')
    EventBus.$off('refreshRightScoreBoard')
    EventBus.$off('activeRbScoreBoard')
    // EventBus.$off('activeAllBetOsScoreBoard')
  },
}
var playframe_original_style;
  window.addEventListener("message", function(ev){
      if (typeof ev.data !== "object") return;
      if (!ev.data.type) return;
      if (ev.data.type !== "full_screen_click") return;
      var playframe_message = ev.data.message;
      var playframe = document.getElementById("livetv"); // can replace with your iframe id

      if (Object.keys(playframe_message).length > 0){
          var playframe_fullscreen_style = "";
          Object.keys(playframe_message).forEach((val, idx) => {
              var style_name = val;
              playframe_fullscreen_style += `${style_name}: ${playframe_message[val]};`;
          });
          playframe_original_style = playframe.getAttribute("style");
          playframe.setAttribute("style", playframe_fullscreen_style);
          $('.nicescroll-cursors').css('display', 'none');
          $('.v-scroll-area').css('display', 'block');
          $('.c-site-header .header-item.item2').css('z-index', '45');
          $('.scroll-fixed-headerA').css('z-index', '46');
          $('.yb-match-list').css('z-index', '46');
      } else{
            $('.nicescroll-cursors').css('display', '');
            $('.c-site-header .header-item.item2').css('z-index', '47');
            $('.scroll-fixed-headerA').css('z-index', '48');
            $('.v-scroll-area').css('display', '');
            $('.yb-match-list').css('z-index', '48');
          if(playframe_original_style != null){
              playframe.setAttribute("style", playframe_original_style);
          }
          else{
              playframe.removeAttribute("style");
          }
      }
  });
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBetHeader.vue